import './campagneapp.scss'

import * as Sentry from '@sentry/react'

import {
	Action,
	Actions,
	Choosecategory,
	Cookies,
	Error404,
	Home as HomeCampagne,
	Inspiration,
	Inspirations,
	Page,
	Products,
	RegisterAction
} from './views/campagne/pages/index'
import React, {useRef} from 'react'
import {Route, Router} from 'react-router'
import {ThemeProvider, createMuiTheme} from '@material-ui/core'

import {CookiesProvider} from './cookies/cookies'
import {Fetcher} from '@codeurs/front'
import {LanguageProvider} from './util/i18n'
import {PageData} from 'types'
import ReactDOM from 'react-dom'
import {ScrollMemory} from './util/scrollmemory'
import {createBrowserHistory} from 'history'

if (process.env.SENTRY_DSN_CAMPAGNE)
	Sentry.init({
		dsn: process.env.SENTRY_DSN_CAMPAGNE,
		environment: process.env.NODE_ENV,
		allowUrls: [/https?:\/\/campagne\.broederlijkdelen\.be/]
	})

const campagnePages = {
	action: Action,
	actions: Actions,
	choose_category: Choosecategory,
	cookies: Cookies,
	error404: Error404,
	home: HomeCampagne,
	inspiration: Inspiration,
	inspirations: Inspirations,
	page: Page,
	products: Products,
	register_action: RegisterAction
}

const initial = window['__INITIAL_STATE__'] || {}

const history = createBrowserHistory()

const MuiTheme = createMuiTheme({
	typography: {
		fontFamily: 'inherit'
	},
	palette: {
		primary: {
			main: '#61c250'
		},
		secondary: {
			main: '#61c250'
		}
	}
})

export const CampagneApp = () => {
	const currentLocation = useRef()

	return (
		<Router history={history}>
			<Route>
				{({location}) => {
					const {pathname} = location
					return (
						<Fetcher<PageData>
							url={`${pathname.replace(/\/$/, '')}?json`}
							hydrate={initial}
						>
							{({isLoading, data, error}) => {
								const language = data.language
								const {channel, key: pageKey, cookies, ...entry} = data
								const View = campagnePages[pageKey] || campagnePages[channel]
								const props = {...entry, pageKey, channel, isLoading, error}
								const view = View.prototype.render ? (
									<View {...props} />
								) : (
									View(props)
								)
								if (pathname === (data.url || '/')) {
									currentLocation.current = location
									document.title =
										(data.metadata && data.metadata.title) || data.title
								}
								return (
									<LanguageProvider language={language}>
										<CookiesProvider config={cookies} page={data}>
											<ThemeProvider theme={MuiTheme}>
												<ScrollMemory
													history={history}
													location={currentLocation.current || location}
												/>
												{view}
											</ThemeProvider>
										</CookiesProvider>
									</LanguageProvider>
								)
							}}
						</Fetcher>
					)
				}}
			</Route>
		</Router>
	)
}
ReactDOM.render(<CampagneApp />, document.getElementById('root'))
